import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@/components/common/Dialog";
import { Button } from "@/components/ui/button";
import TrashCanDefault from "@/assets/svg/TrashCan.svg";

interface DeletePortfolioProgramConfirmDialogProps {
  isOpen: boolean;
  isPortfolio: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  trashIcon?: string;
}

export const DeletePortfolioProgramConfirmDialog: React.FC<
  DeletePortfolioProgramConfirmDialogProps
> = ({
  isOpen,
  isPortfolio,
  isLoading = false,
  onClose,
  onConfirm,
  trashIcon,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog isOpen={isOpen} onClose={onClose} modalClass="rounded-lg">
      <div className="flex flex-col gap-2 p-6 text-center">
        <img
          src={trashIcon || TrashCanDefault}
          className="w-12 m-auto"
          alt={t("delete")}
        />
        {isPortfolio ? t("remove_portfolio") : t("remove_program")}
        <span className="text-xs text-gray-600">
          {isPortfolio
            ? t("remove_portfolio_description")
            : t("remove_program_description")}
        </span>
        <div className="flex gap-2 ml-auto">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            className="text-white"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
          >
            {t("delete")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DeletePortfolioProgramConfirmDialog;
